import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Dark mode is the default for this site.
document.documentElement.classList.add('dark');
document.documentElement.dataset.appVersion = __APP_VERSION__;

const versionMeta = document.createElement('meta');
versionMeta.name = 'x-yhazrin-blog-version';
versionMeta.content = __APP_VERSION__;
document.head.appendChild(versionMeta);

window.__YHAZRIN_BLOG_VERSION__ = __APP_VERSION__;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

declare global {
  interface Window {
    __YHAZRIN_BLOG_VERSION__?: string;
  }
}
